/**
 *  @module Icon
 *  @overview An SVG or URL icon
 */

import * as allIcons from './all-icons';
import type { IconName } from './all-icons';
import PictureRetina from '../picture-fill/picture-fill';
import PictureRetinaAssets from '../picture-fill-assets/picture-fill-assets';

export type IconPropsType = {
  height?: number | string;
  altText?: string;
  color?: string;
  width?: number | string;
  stroke?: string;
  containerStyle?: any;
  cloudinaryFilters?: string;
  className?: string;
  icon?: IconName;
  iconUrl?: string;
  iconAssetUrl?: {
    url: string;
    url2x?: string;
  };
};

const Icon = (props: IconPropsType) => {
  const {
    color,
    height,
    altText,
    stroke,
    width,
    cloudinaryFilters,
    className = '',
  } = props;
  if (props.iconUrl) {
    return (
      <PictureRetina
        class={className}
        url={props.iconUrl}
        alt={altText || ''}
        cloudinaryFilters={
          cloudinaryFilters ||
          `w_${width || 56},h_${height || 56},c_thumb,r_max`
        }
      />
    );
  }

  if (props.iconAssetUrl) {
    return (
      <PictureRetinaAssets
        class={className}
        url={props.iconAssetUrl.url}
        url2x={props.iconAssetUrl.url2x}
      />
    );
  }

  if ((!props.iconUrl && !props.iconAssetUrl) || props.icon) {
    const SvgIcon =
      props.icon && allIcons[props.icon]
        ? allIcons[props.icon]
        : allIcons['Placeholder'];
    return (
      <span className={className}>
        <SvgIcon
          color={color || stroke}
          height={height ?? 56}
          width={width ?? 56}
        />
      </span>
    );
  }

  return null;
};

Icon.displayName = 'Icon';

export default Icon;
